import api from './api'

const ENDPOINT = '/admin/roles'

const RolesService = {
  /**
   * Get all roles with pagination
   * @param {Object} params - Query params { page, per_page }
   * @returns {Promise} - Paginated list of roles
   */
  async getAll(params = {}) {
    const response = await api.get(ENDPOINT, { params })
    return response.data
  },

  /**
   * Get single role by ID
   * @param {number} id - Role ID
   * @returns {Promise} - Role data
   */
  async getById(id) {
    const response = await api.get(`${ENDPOINT}/${id}`)
    return response.data
  },

  /**
   * Create new role
   * @param {Object} data - Role data { name, permissions: [ids] }
   * @returns {Promise} - Created role
   */
  async create(data) {
    const response = await api.post(ENDPOINT, data)
    return response.data
  },

  /**
   * Update role
   * @param {number} id - Role ID
   * @param {Object} data - Role data { name, permissions: [ids] }
   * @returns {Promise} - Updated role
   */
  async update(id, data) {
    const response = await api.put(`${ENDPOINT}/${id}`, data)
    return response.data
  },

  /**
   * Delete role
   * @param {number} id - Role ID
   * @returns {Promise} - Delete response
   */
  async delete(id) {
    const response = await api.delete(`${ENDPOINT}/${id}`)
    return response.data
  },

  /**
   * Get all available permissions
   * @returns {Promise} - List of permissions
   */
  async getPermissions() {
    const response = await api.get(`${ENDPOINT}/permissions`, { params: { _no_pagination_: 1 } })
    return response.data
  },
}

export default RolesService
